import React from "react";
import "./frames-cards.css";
import { Link } from "react-router-dom";
import Favourite_icon from "../../favourite-icon/Favourite_icon";
import { encodeId } from "../../../../utils/common";
import InnerImageZoom from 'react-inner-image-zoom';

const Frames_card = (props) => {
  return (
    <>
      <section className="Frames_card">
        <Link to={`/product-descrption/${encodeId(props?.id)}`}>
          <div className="imagesec">
            <img
              className="frame_img"
              src={process.env.REACT_APP_IMAGE_URL + props.image}
              alt="frame-img"
            />
          </div>

          <div className="card-content">
            <p className="type">{props.type}</p>
            <p className="name">{props.name}</p>
            <p className="prise">
              ₹<span>{props.prise}</span>-
              <span className="oldprise">₹{props.oldprise}</span>
            </p>
          </div>
        </Link>
        <div className="faviconoverlay">
          <Favourite_icon id={props?.id} />
        </div>
      </section>
    </>
  );
};

export default Frames_card;
